import { ImageStyle, KeyboardTypeOptions, StyleSheet, Text, TextInput, View, ViewStyle } from "react-native"
import { black90, color_333333, color_BEBEBE, color_main, ColorF6F6F6 } from "../../assets/style/colors"
import { ImageView } from "../../components/ImageView"

export type LoginInputProp = {
    placeholder: string,
    style?: ViewStyle,
    imgStyle?: ImageStyle,
    source?: JSX.Element,
    secureTextEntry?: boolean,
    label: string,
    text: string,
    onChangeText: (text: string) => void,
    showClean?: boolean
    autoFocus?: boolean
    focusable?: boolean
    keyboardType?: KeyboardTypeOptions
    maxLength?: number
    editable?: boolean
    onFocus?: () => void,
    onBlur?: () => void,
    rightIcon?: JSX.Element,
}

export const LoginInput = (props: LoginInputProp) => {
    return (<View style={{ marginTop: 14, }}>
        <View style={{ flexDirection: 'row' }}>
            {props.source && props.source}
            <Text style={{
                fontSize: 14,
                color: black90,
                fontWeight: '400',
                fontFamily: '',
                marginStart: 10
            }}>{props.label}</Text>
        </View>
        <View style={[styles.inputBg, { paddingEnd: (props.showClean === true) ? 10 : 16 }, props.style]}>
            <TextInput
                placeholder={props.placeholder}
                editable={props.editable !== false}
                focusable={props.focusable !== false}
                autoFocus={props.autoFocus}
                autoCapitalize="none"
                autoComplete="off"
                autoCorrect={false}
                selectionColor={color_main}
                placeholderTextColor={color_BEBEBE}
                style={[styles.input, { flex: 1 }]}
                value={props.text}
                onFocus={(e) => {
                    // 阻止事件冒泡，防止 Pressable 的 onPress 触发
                    e.stopPropagation();
                    props.onFocus?.();
                }}
                onBlur={props.onBlur}
                maxLength={props.maxLength}
                keyboardType={props.keyboardType}
                secureTextEntry={props.secureTextEntry}
                onChangeText={props.onChangeText} />
            {/* 清除按钮 */}
            {props.showClean === true && props.text.length > 0 && <ImageView
                activeOpacity={1}
                style={{ padding: 6 }}
                onClick={() => {
                    props.onChangeText("");
                }} source={require("../../assets/image/icon_del.png")} />}

            {props.rightIcon && props.rightIcon}
        </View>
    </View>
    )
}
const styles = StyleSheet.create({
    inputBg: {
        flexDirection: "row",
        backgroundColor: ColorF6F6F6,
        borderRadius: 5,
        alignItems: "center",
        height: 48,
        paddingStart: 16,
        marginTop: 10,
    },
    input: {
        height: 40,
        flex: 1,
        color: color_333333,
    },
});